import React from 'react'
import { Link } from 'react-router-dom'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import UwagaComponent from '../UwagaComponent/UwagaComponent'
import './StartComponent.css'
import WriteIcon from '../../icons/WriteIcon'
import QRIcon from '../../icons/QRIcon'

const usePlatform = () => {
  const [platform, setPlatform] = React.useState({ isIOS: false, isAndroid: false })
  React.useEffect(() => {
    const userAgent = navigator.userAgent
    setPlatform({
      isIOS: /iPhone|iPad|iPod/.test(userAgent),
      isAndroid: /Android/.test(userAgent)
    })
  }, [])
  return platform
}

const StartComponent = () => {
  const { isIOS, isAndroid } = usePlatform()

  return (
    <Container maxWidth='lg'>
      <Grid container spacing={2} alignItems='center' justifyContent='center' className='start-grid-info' mt={6}>
        <Grid>
          <div className='element-hello'>Dzień dobry!</div>
        </Grid>
      </Grid>
      <Grid container spacing={2} alignItems='center' justifyContent='center' className='start-grid-info'>
        <Grid item xs={12}>
          <div className='element-info'>Witaj w systemie informacji gastronomicznej ABSPOS</div>
        </Grid>
      </Grid>
      <Link to='/scanner' className='link-no-decoration'>
        <Card variant='outlined' className='element-card-scanner'>
          <CardHeader avatar={<QRIcon />} title='Skanuj kod QR widoczny na rachunku' />
        </Card>
      </Link>
      <Link to='/form' className='link-no-decoration'>
        <Card variant='outlined' className='element-card-write'>
          <CardHeader avatar={<WriteIcon />} title='Przepisz numer zamówienia widoczny na rachunku' />
        </Card>
      </Link>
      {(isIOS || isAndroid) && <UwagaComponent />}
      <div className='pustota'></div>
    </Container>
  )
}

export default StartComponent
